import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DashboardHostComponent } from "src/app/shared/components/DynamicDashboardWidgets";

@Component({
  selector: 'app-dashboard-preview',
  imports: [DashboardHostComponent],
  templateUrl: './dashboard-preview.component.html',
  styleUrl: './dashboard-preview.component.scss'
})
export class DashboardPreviewComponent implements OnInit {

dashboardId:any;

constructor(private route: ActivatedRoute) {}

ngOnInit(): void {
  this.route.paramMap.subscribe(params => {
      const idParam = params.get('dshId');
       this.dashboardId = idParam ? Number(idParam) : (history.state?.dashboardId ?? undefined);
    });
}

}
